import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-foreground-300">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-2xl text-white whitespace-nowrap">
              牛牛影视
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              牛牛超清不缓冲流畅播放平台，提供高清电影、电视剧、动漫、综艺免费在线观看。牛牛极清画质，沉浸式追剧观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">电影</Link>
              <Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">电视剧</Link>
              <Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">动漫</Link>
              <Link to="/category/variety" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">综艺</Link>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-white mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">用户口碑</Link>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-white mb-4">特色功能</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-400">牛牛超清画质</span>
              <span className="text-sm text-foreground-400">牛牛不缓冲技术</span>
              <span className="text-sm text-foreground-400">牛牛极清模式</span>
              <span className="text-sm text-foreground-400">牛牛流畅播放</span>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-foreground-500">
            &copy; {currentYear} 牛牛影视 版权所有 | 牛牛超清不缓冲流畅播放
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}